/**
 * Formats DOB from YYYY-MM-DD to MM/DD/YYYY
 * @param dobString - Date string in YYYY-MM-DD format
 * @returns Formatted date string in MM/DD/YYYY format, or "--" if invalid
 */
export const formatDob = (dobString: string | undefined): string => {
  if (!dobString || dobString === "--") return "--";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dobString);
  if (!match) return "--";
  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
};
